import { ITokenDecoder } from "@/domain/repositories/DecodeToken";
import { ISessionManager } from "@/domain/repositories/Session";
import { ContentToken } from "@/types/src/backend/utils/jwt";

export class SessionUseCase {
  constructor(
    private readonly session: ISessionManager,
    private readonly decoder: ITokenDecoder
  ) {}

  async createSession(token: string, refreshToken: string) {
    const authData = { token, refreshToken };
    await this.session.createSession(authData);
  }

  async deleteSession() {
    await this.session.deleteSession();
  }

  async getTokenData(): Promise<ContentToken> {
    const session = await this.session.getSession();
    if (!session) {
      throw new Error("Session not found");
    }
    const userData: ContentToken = await this.decoder.decode(session.token);

    if (!userData || !userData.userId) {
      throw new Error("Could not decode userData from token");
    }

    return userData;
  }

  async getSession() {
    const session = await this.session.getSession();
    if (!session) {
      throw new Error("Session not found");
    }

    return session;
  }

  async getToken() {
    const session = await this.session.getSession();
    if (!session || !session.token) {
      throw new Error("Session not found");
    }

    return session.token;
  }
}
